import styled from 'styled-components';

export const Slot = styled.div`
  &:empty {
    display: none;
  }
`;
